var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 247,
    viewBox: "0 0 232 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7462 2.2036C49.1247 2.47107 43.5033 8.0879 42.6121 13.3035C34.7969 33.3636 25.405 73.2164 23.2798 102.838C22.6628 112.534 21.9772 121.695 22.0458 128.315L22.2515 175.657C22.2515 186.89 23.554 196.385 24.9936 206.482C24.9936 206.482 24.9936 206.549 24.9936 206.683C26.2962 215.911 34.5913 221.728 46.9311 221.728C92.8625 221.728 139 221.728 184.863 221.728C197.134 221.728 205.497 215.977 206.8 206.683C206.8 206.616 206.8 206.549 206.8 206.549C208.24 196.452 209.542 187.024 209.542 175.724L209.748 128.315C209.816 121.695 209.131 112.601 208.514 102.772C206.457 73.1495 196.654 33.3636 189.182 13.3035C188.29 8.15477 182.669 2.53794 177.047 2.27047C154.15 1.46807 139 1 115.897 1C92.8624 1 77.7119 1.33433 54.7462 2.2036Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.562 174.519C197.272 179.066 191.376 179.333 186.44 179.734C182.327 180.069 165.6 180.202 161.486 180.135C163.749 173.984 167.176 163.553 171.084 162.082C173.826 161.012 177.597 160.009 181.916 159.541C183.767 159.341 196.998 158.07 202.413 158.405C203.03 164.355 202.345 171.911 200.562 174.519Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2 188.428C208.651 194.646 207.829 200.196 206.869 206.415C206.869 206.415 206.869 206.482 206.869 206.616C205.635 215.509 197.82 221.193 186.303 221.594V242.322C186.303 244.395 188.085 246 190.279 246H205.498C207.692 246 209.474 244.395 209.474 242.322V187.492C209.405 187.826 209.337 188.16 209.2 188.428Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.715 102.637C204.126 106.916 204.675 115.274 204.949 119.286L226.475 118.551C228.737 118.484 230.931 116.545 230.931 114.205L231 94.1452C231 91.805 228.6 89.799 226.544 89.799L219.14 90.2002C217.083 90.2002 214.684 92.6073 214.684 94.5464L214.821 102.57L203.715 102.637Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.817 147.974L209.748 151.852C210.776 151.518 211.53 150.715 211.53 149.846C211.53 149.044 210.776 148.308 209.817 147.974Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6602 114.674L37.3339 50.6155C46.0403 47.6734 81.3459 47.339 115.692 47.339C150.037 47.339 185.48 47.6734 194.529 50.6155L197.271 114.674H34.6602Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.334 47.4722C46.0404 44.5302 81.346 44.1958 115.692 44.1958C150.038 44.1958 185.48 44.5302 194.529 47.4722",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4352 50.3479C59.7511 48.3418 76.8897 48.5424 93.2742 48.3418C123.781 48.3418 154.562 47.6732 185 49.9467C187.4 50.2141 191.376 50.4147 193.569 51.284L196.175 113.604L35.6885 113.537L38.2251 51.2171C39.8019 50.8159 41.7899 50.6153 43.4352 50.3479Z",
    fill: "#F6F6F6",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.881 119.822H195.969C199.054 119.822 202.139 119.354 204.881 118.418",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.639 158.338L197.203 114.674",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.988 24.6031C190.279 30.1529 193.432 41.5867 194.666 50.6802C194.255 42.3891 194.461 39.5807 197.614 36.973",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.404 178.598L190.484 183.813",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200.356 52.0187C198.642 58.0367 200.356 77.2275 203.784 102.503",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.48 158.337C203.303 155.663 205.771 154.058 209.816 153.456",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.704 183.746L161.555 180.136",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.346 114.139C172.455 136.606 171.427 157.268 168.342 164.624",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.346 114.139C172.455 136.606 171.427 157.268 168.342 164.624",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4378 174.519C34.7284 179.066 40.6241 179.333 45.5601 179.734C49.6733 180.069 66.4005 180.202 70.5138 180.135C68.2515 173.984 64.8238 163.553 60.9162 162.082C58.174 161.012 54.4035 160.009 50.0846 159.541C48.2336 159.341 35.0026 158.07 29.5868 158.405C28.9699 164.355 29.5868 171.911 31.4378 174.519Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7312 188.428C23.2796 194.646 24.1022 200.196 25.062 206.415C25.062 206.415 25.062 206.482 25.062 206.616C26.2959 215.509 34.1112 221.193 45.6283 221.594V242.322C45.6283 244.395 43.846 246 41.6523 246H26.4331C24.2393 246 22.457 244.395 22.457 242.322V187.492C22.5256 187.826 22.6626 188.16 22.7312 188.428Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2847 102.637C27.8734 106.916 27.3249 115.274 27.0507 119.286L5.52449 118.551C3.2622 118.484 1.06845 116.545 1.06845 114.205L1 94.1452C1 91.805 3.39941 89.799 5.45604 89.799L12.86 90.2002C14.9166 90.2002 17.316 92.6073 17.316 94.5464L17.1788 102.57L28.2847 102.637Z",
    fill: "white",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1152 147.974L22.1837 151.852C21.1554 151.518 20.4014 150.715 20.4014 149.846C20.4014 149.044 21.1555 148.308 22.1152 147.974Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.119 119.822H36.0312C32.9463 119.822 29.8613 119.354 27.1191 118.418",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3617 158.338L34.7969 114.674",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0117 24.6031C41.7211 30.1529 38.5676 41.5867 37.3336 50.6802C37.7449 42.3891 37.5392 39.5807 34.3857 36.973",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5957 178.598L41.4466 183.813",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5752 52.0187C33.289 58.0367 31.5752 77.2275 28.1475 102.503",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4505 158.337C28.6279 155.663 26.1599 154.058 22.1152 153.456",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2276 183.746L70.4453 180.136",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6543 114.139C59.5455 136.606 60.5739 157.268 63.6588 164.624",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6543 114.139C59.5455 136.606 60.5739 157.268 63.6588 164.624",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1365 221.593C34.8653 221.593 26.5016 215.842 25.1991 206.548C25.1991 206.481 25.1991 206.348 25.1991 206.348C24.0337 198.524 23.0053 191.504 22.5254 183.146C26.2959 183.547 29.9979 183.747 33.9055 183.747H72.4331C73.3243 184.684 74.6954 185.218 76.2036 185.218C102.734 186.155 129.402 186.155 156.001 185.218C157.509 185.218 158.88 184.75 159.771 183.747H198.299C202.138 183.747 205.909 183.547 209.611 183.146C209.199 191.571 208.171 198.524 207.005 206.414C207.005 206.414 207.005 206.481 207.005 206.615C205.703 215.842 197.339 221.659 185.068 221.659L47.1365 221.593Z",
    fill: "#FAFAFA",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M207.349 200.664C207.349 200.664 207.349 200.731 207.349 200.865C206.047 210.092 197.683 215.909 185.412 215.909L47.5487 215.842C35.2775 215.842 26.9139 210.092 25.6113 200.798C25.6113 200.731 25.6113 200.597 25.6113 200.597",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.486 180.002C163.131 175.656 165.325 169.17 167.793 165.225H64.207C66.7435 169.237 69.0059 175.722 70.5826 180.069L72.4336 183.746C73.3248 184.682 74.6959 185.217 76.2041 185.217C102.735 186.086 129.402 186.086 156.001 185.217C157.51 185.217 158.881 184.749 159.772 183.746L161.486 180.002Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.034 160.745C121.107 160.745 125.289 164.824 125.289 169.839C125.289 174.786 121.107 178.865 116.034 178.865C110.893 178.865 106.711 174.786 106.711 169.839C106.711 164.824 110.893 160.745 116.034 160.745Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116.034 157.736C117.056 157.736 117.885 156.927 117.885 155.93C117.885 154.933 117.056 154.125 116.034 154.125C115.011 154.125 114.183 154.933 114.183 155.93C114.183 156.927 115.011 157.736 116.034 157.736Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M116.034 163.42C119.599 163.42 122.547 166.295 122.547 169.839C122.547 173.316 119.599 176.191 116.034 176.191C112.401 176.191 109.453 173.316 109.453 169.839C109.453 166.295 112.401 163.42 116.034 163.42Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7542 197.054H138.315C139.48 197.054 140.44 198.391 140.44 199.126V205.947C140.44 206.682 139.069 208.019 138.315 208.019H93.7542C93.0001 208.019 91.6289 207.083 91.6289 205.947V199.126C91.6289 197.923 92.5887 197.054 93.7542 197.054Z",
    fill: "#E4E4E4",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M115.896 186.89H191.306C197.408 186.89 204.675 186.823 209.199 186.088",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M115.76 186.89H40.3496C34.2483 186.89 26.9816 186.823 22.457 186.088",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M154.356 207.016C153.122 207.016 152.711 205.947 153.054 205.01C155.247 199.594 159.498 196.452 164.776 196.251C171.358 195.984 178.967 195.85 187.399 195.85C188.702 195.85 189.25 196.117 188.976 197.254C188.359 199.862 186.714 201.734 184.931 203.874C184.109 204.81 180.201 206.214 178.967 206.348C173.208 206.749 164.571 207.016 154.356 207.016Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3002 207.016C78.5342 207.016 78.9454 205.947 78.6027 205.01C76.4089 199.594 72.1585 196.452 66.8798 196.251C60.2986 195.984 52.689 195.85 44.2568 195.85C42.9543 195.85 42.406 196.117 42.6802 197.254C43.2972 199.862 44.9424 201.734 46.7249 203.874C47.5475 204.81 51.4551 206.214 52.6891 206.348C58.4476 206.749 67.0856 207.016 77.3002 207.016Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M187.468 195.85H197.751C201.864 195.85 205.36 195.516 208.445 194.981",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1887 195.85H33.9055C29.7922 195.85 26.2959 195.516 23.2109 194.981",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8496 189.164H154.151L152.163 191.37H79.8378L77.8496 189.164Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8662 192.239H151.203L149.215 194.445H82.7858L80.8662 192.239Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9941 197.121H160.663",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6035 204.81H91.5602",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.371 204.81H153.259",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M168.89 164.02C170.946 158.136 185.274 156.799 193.706 154.993C199.945 153.656 205.361 147.839 209.954 137.475",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0418 164.02C60.9851 158.136 46.6573 156.799 38.2251 154.993C31.9866 153.656 26.5707 147.839 21.9775 137.475",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M202.618 164.958L209.199 163.219C207.211 167.097 205.909 173.851 205.223 183.613",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3127 164.958L22.7314 163.219C24.7195 167.097 26.0221 173.851 26.7076 183.613",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9023 230.354L81.0022 226.142H116.102H151.202L186.37 230.354V228.147V225.941V223.668V221.394H151.202H116.102H81.0022H45.9023V223.668V225.941V228.147V230.354Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.003 115.677H58.9971V118.686H173.003V115.677Z",
    fill: "#E8E8E8",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.334 47.3388C46.0404 44.3968 81.346 44.0625 115.692 44.0625C150.038 44.0625 185.48 44.3968 194.529 47.3388",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3238 2.3363C49.5369 11.029 38.6367 41.4535 37.4027 50.5474C37.814 42.2559 38.3625 39.4475 35.209 36.8397L42.3387 38.8457H121.793",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M175.608 2.3363C182.395 11.029 193.295 41.4535 194.529 50.5474C194.118 42.2559 193.569 39.4475 196.723 36.8397L189.593 38.8457H110.139",
    stroke: "#939EAF",
    strokeWidth: 0.481245,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleFront);
export default __webpack_public_path__ + "static/media/vehicle-front.c891ab79acefc75a20b796bb41adcdd3.svg";
export { ForwardRef as ReactComponent };